import React, { createContext, useState, useEffect, useContext } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const lastLogin = localStorage.getItem('lastLogin');
    if (lastLogin) {
      const timeDiff = Date.now() - parseInt(lastLogin, 10);
      if (timeDiff < 3 * 60 * 60 * 1000) { // 3 hours
        setIsAuthenticated(true);
      }
    }
  }, []);

  const login = () => {
    setIsAuthenticated(true);
    localStorage.setItem('lastLogin', Date.now().toString());
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('lastLogin');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};